export default "__VITE_ASSET__CRArSpIZ__"